// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1iimn","field":"styles_field__2iROO","fieldCol":"styles_fieldCol__1a3eT","diffCol":"styles_diffCol__3jQd6","diff":"styles_diff__M_OdL"};